import React from 'react';
import { Container } from 'react-bootstrap';
import { withAuthorization } from '../Session';
import AllList from './AllList';

class GCCategory extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Container>
                <AllList {...this.props} />
            </Container>
        );
    }
}

const condition = (authUser) => !!authUser;
export default withAuthorization(condition)(GCCategory);
